module.exports = __webpack_public_path__ + "img/photo8.33dfd5f8.png";